// index.js
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducers"; // Assure-toi que le fichier et l'import sont cohérents

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware({
            serializableCheck: false,
        });
    },
    devTools: true,
});

export default store;
